export const companiesApi = {
  companies: {
    queryKey: (params?: string[]) => ["companies", ...(params || [])],
    route: () => `companies`,
    methods: ["GET", "POST"],
  },
  company: {
    queryKey: (id: number, params?: string[]) => [
      "companies",
      id,
      ...(params || []),
    ],
    route: (id: number) => `companies/${id}`,
    methods: ["PATCH", "DELETE"],
  },
  uploads: {
    route: () => `uploads`,
    deleteRoute: (type: string, id: number) => `uploads/${type}/${id}`,
  },
};
